// Mock data for Jhumar Collection - Luxury Lighting Store

export const BUSINESS = {
  name: "Jhumar Collection",
  legalName: "Jhumar Collection Private Limited",
  gstin: "27AAHCJ5623J1ZC",
  address: {
    line1: "Shop No. F14, First Floor, Supermall",
    line2: "Next to Hotel South Samrat, Salunkhe Vihar Road",
    line3: "Survey No. 69/1A/1C, Wanawadi",
    city: "Pune",
    state: "Maharashtra",
    pin: "411048",
  },
  phone: "+91 70099 72766",
  email: "admin@jhumarcollection.com",
  hours: "Mon–Sat, 10:30am – 8:30pm",
  directors: ["Prakash Daroga", "Lokesh Regar"],
};

export const NAV_CATEGORIES = [
  "Chandeliers",
  "Pendants",
  "Wall Lights",
  "Ceiling",
];

export const MARQUEE_ITEMS = [
  "Free shipping across India on orders over \u20b92,999",
  "New season chandeliers & pendants",
  "Easy 7-day returns",
  "Secure UPI & Cash on Delivery",
];

export const SUB_NAV = [
  "Crystal", "Brass", "Modern", "Jhumar",
];

export const HERO = {
  eyebrow: "New Season \u00b7 2026",
  titlePre: "Light that",
  titleAccent: "defines a room",
  description:
    "Handpicked chandeliers, pendants and wall lights \u2014 crafted with real crystal and solid brass, at honest, all-inclusive prices delivered across India.",
  ctaPrimary: { label: "Shop Chandeliers", href: "#chandeliers" },
  ctaSecondary: { label: "Shop Pendants", href: "#pendants" },
  badges: [
    { title: "\u20b92,999+", subtitle: "Free shipping" },
    { title: "7 days", subtitle: "Easy returns" },
    { title: "Pan-India", subtitle: "Fast dispatch" },
    { title: "UPI & COD", subtitle: "Secure checkout" },
  ],
};

export const CATEGORY_TILES = [
  {
    id: "chandeliers",
    letter: "C",
    title: "The Chandelier Edit",
    label: "Chandeliers",
    cta: "Shop Chandeliers",
    image:
      "https://images.unsplash.com/photo-1509437142917-63dfe86dcbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "pendants",
    letter: "P",
    title: "The Pendant Edit",
    label: "Pendants",
    cta: "Shop Pendants",
    image:
      "https://images.unsplash.com/photo-1540932239986-30128078f3c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const EDIT_PRODUCTS = [
  {
    slug: "celeste-8-arm-crystal-chandelier",
    name: "Celeste 8-Arm Crystal Chandelier",
    category: "Chandeliers",
    price: 24999,
    image:
      "https://images.unsplash.com/photo-1509437142917-63dfe86dcbec?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Hand-cut K9 crystal drops on an antique brass frame. 8 candelabra bulbs (E14, 40W each), 80 cm drop x 70 cm dia. Ideal above dining tables and 10–12 ft ceilings.",
  },
  {
    slug: "aurora-brass-pendant",
    name: "Aurora Brushed Brass Pendant",
    category: "Pendants",
    price: 5499,
    image:
      "https://images.unsplash.com/photo-1540932239986-30128078f3c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Solid brass shade with a brushed champagne finish and warm interior lining. E27 bulb, adjustable cord up to 150 cm. Perfect over kitchen islands and bar counters.",
  },
  {
    slug: "halo-ring-led-ceiling",
    name: "Halo Ring LED Ceiling Light",
    category: "Ceiling",
    price: 7299,
    image:
      "https://images.unsplash.com/photo-1606170033648-5d55a3edf314?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Slim aluminium ring with a diffused acrylic face. 60 W integrated LED, 3-tone (warm/neutral/cool) via wall switch. 60 cm dia — flush mount for living rooms and bedrooms.",
  },
  {
    slug: "venetian-tiered-jhumar",
    name: "Venetian Tiered Crystal Jhumar",
    category: "Chandeliers",
    price: 42999,
    image:
      "https://images.unsplash.com/photo-1627306411131-358d6d0fd2cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Two-tier Venetian-style jhumar with cascading crystal beads on a champagne gold frame. 12 candelabra bulbs (E14). 100 cm drop x 80 cm dia. Statement piece for foyers and lobbies.",
  },
  {
    slug: "opal-globe-wall-sconce",
    name: "Opal Globe Wall Sconce",
    category: "Wall Lights",
    price: 3299,
    image:
      "https://images.unsplash.com/photo-1544125488-1bd845a0d0c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Frosted opal glass globe on a matte black arm. E27 bulb (up to 40W). 25 cm projection. IP20 indoor — great as a bedside reader or bathroom vanity light.",
  },
  {
    slug: "noor-hanging-cluster",
    name: "Noor Cluster Hanging Light",
    category: "Pendants",
    price: 8899,
    image:
      "https://images.pexels.com/photos/12202390/pexels-photo-12202390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Cluster of 5 mouth-blown amber glass orbs on adjustable braided cords. 5 x E14 bulbs. Perfect for double-height stairwells and living rooms.",
  },
  {
    slug: "marble-dome-pendant",
    name: "Marble Dome Kitchen Pendant",
    category: "Pendants",
    price: 4599,
    image:
      "https://images.unsplash.com/photo-1515948725-edac7b5bb0fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Natural white marble dome with brass hardware — each stone is unique in veining. E27 bulb. 30 cm dia. Warm downward glow, ideal over kitchen islands.",
  },
  {
    slug: "regent-3-tier-jhumar",
    name: "Regent 3-Tier Jhumar",
    category: "Chandeliers",
    price: 34999,
    image:
      "https://images.unsplash.com/photo-1531762948975-73032b7b61f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Traditional 3-tier jhumar with clear crystal droplets and a polished chrome frame. 15 candelabra bulbs (E14). 110 cm drop x 75 cm dia. Best for wedding halls and grand living rooms.",
  },
];

export const NEW_ARRIVALS = [
  {
    slug: "linen-drum-pendant",
    name: "Linen Drum Pendant Light",
    category: "Pendants",
    price: 3899,
    image:
      "https://images.pexels.com/photos/28678990/pexels-photo-28678990.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Natural linen drum shade with cotton inner diffuser and a black canopy. E27 bulb. 40 cm dia. Soft ambient light — perfect over bedside tables and reading nooks.",
  },
  {
    slug: "amber-glass-sconce",
    name: "Amber Glass Wall Sconce",
    category: "Wall Lights",
    price: 2899,
    image:
      "https://images.unsplash.com/photo-1552085903-5301914d62e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Hand-blown smoked amber glass on antique brass backplate. E14 bulb. 18 cm projection. Warm, sunset-tinted glow — beautiful in hallways and beside mirrors.",
  },
  {
    slug: "midnight-brass-flush",
    name: "Midnight Brass Flush Mount",
    category: "Ceiling",
    price: 4299,
    image:
      "https://images.pexels.com/photos/19840855/pexels-photo-19840855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Low-profile flush mount with a matte black cage and antique brass cluster. 3 x E14 bulbs. 45 cm dia. Ideal for balconies, corridors and low ceilings.",
  },
  {
    slug: "petal-crystal-flush",
    name: "Petal Crystal Flush Chandelier",
    category: "Chandeliers",
    price: 12999,
    image:
      "https://images.pexels.com/photos/5824906/pexels-photo-5824906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Petal-shaped clear crystals arranged in tiers on a chrome frame. 6 x G9 bulbs. 55 cm dia x 40 cm drop. A subtle sparkle for bedrooms with 9–10 ft ceilings.",
  },
  {
    slug: "rattan-dome-pendant",
    name: "Rattan Dome Pendant",
    category: "Pendants",
    price: 3499,
    image:
      "https://images.unsplash.com/photo-1572955034096-233ea61a78d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Hand-woven natural rattan dome with a warm-toned interior. E27 bulb. 35 cm dia. Casts a lovely patterned shadow — perfect for coastal and boho interiors.",
  },
  {
    slug: "maharaja-19-arm",
    name: "Maharaja 19-Arm Grand Jhumar",
    category: "Chandeliers",
    price: 89999,
    image:
      "https://images.pexels.com/photos/28656088/pexels-photo-28656088.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Grand 19-arm jhumar draped with hundreds of hand-cut crystals on a 24k-gold-plated frame. 19 candelabra bulbs (E14). 130 cm drop x 110 cm dia. Made-to-order in 4–6 weeks.",
  },
  {
    slug: "minimal-black-picture-light",
    name: "Minimal Black Picture Light",
    category: "Wall Lights",
    price: 1899,
    image:
      "https://images.unsplash.com/photo-1544125488-1bd845a0d0c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Slim matte black picture light with adjustable arm and integrated 8W LED. Battery or hardwired. Highlights art, mirrors and gallery walls with a soft focused beam.",
  },
  {
    slug: "pearl-3-light-cluster",
    name: "Pearl 3-Light Cluster",
    category: "Pendants",
    price: 6499,
    image:
      "https://images.unsplash.com/photo-1540932239986-30128078f3c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Three pearl-white ceramic pendants on a linear brass canopy. 3 x E27 bulbs. 90 cm rail. Balanced everyday lighting for dining tables and kitchen islands.",
  },
];

export const BUDGET_PICKS = [
  {
    slug: "tea-light-brass-holder",
    name: "Solitaire Brass Tea-Light Holder",
    category: "Accents",
    price: 100,
    image:
      "https://images.unsplash.com/photo-1544125488-1bd845a0d0c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Solid brass tea-light holder with an anti-tarnish finish. Fits a standard 38 mm tea-light. Perfect for pooja spaces, dinner tables and cosy corners.",
  },
  {
    slug: "edison-vintage-bulb",
    name: "Edison Vintage Filament Bulb",
    category: "Bulbs",
    price: 200,
    image:
      "https://images.unsplash.com/photo-1515948725-edac7b5bb0fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "ST64 Edison-style filament bulb, E27 base, 4W (equivalent 40W), 2200K warm amber glow. Non-dimmable. 15,000-hour rated life.",
  },
  {
    slug: "mini-copper-spotlight",
    name: "Mini Copper Spotlight",
    category: "Wall Lights",
    price: 500,
    image:
      "https://images.unsplash.com/photo-1552085903-5301914d62e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Adjustable mini spotlight with brushed copper cone. GU10 bulb (not included). 12 cm projection. Highlights artwork, plants and shelves with a focused beam.",
  },
  {
    slug: "glass-tumbler-pendant",
    name: "Clear Glass Tumbler Pendant",
    category: "Pendants",
    price: 700,
    image:
      "https://images.pexels.com/photos/12202390/pexels-photo-12202390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Clear ribbed glass tumbler on a matte black cord. E27 bulb. 12 cm dia x 25 cm height. Pairs beautifully in a row over kitchen counters.",
  },
  {
    slug: "brass-cone-wall-lamp",
    name: "Brass Cone Wall Lamp",
    category: "Wall Lights",
    price: 1000,
    image:
      "https://images.pexels.com/photos/28678990/pexels-photo-28678990.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Minimal brass cone wall lamp with a rotatable head. E27 bulb. 20 cm projection. A clean choice for bedside reading or stair wall accents.",
  },
  {
    slug: "smoked-globe-pendant",
    name: "Smoked Globe Pendant",
    category: "Pendants",
    price: 1500,
    image:
      "https://images.unsplash.com/photo-1572955034096-233ea61a78d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Smoked grey blown glass globe with a matte gold canopy and 100 cm adjustable cord. E27 bulb. 25 cm dia. Moody, refined light for entryways and bar counters.",
  },
  {
    slug: "twin-arm-brass-sconce",
    name: "Twin-Arm Brushed Brass Sconce",
    category: "Wall Lights",
    price: 3000,
    image:
      "https://images.unsplash.com/photo-1544125488-1bd845a0d0c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    description:
      "Twin-arm sconce with opal glass shades on a brushed brass plate. 2 x E14 bulbs. 30 cm width. A designer bedside pair for master bedrooms.",
  },
  {
    slug: "crystal-drop-pendant",
    name: "Crystal Drop Mini Pendant",
    category: "Pendants",
    price: 5000,
    image:
      "https://images.pexels.com/photos/5824906/pexels-photo-5824906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=800",
    description:
      "Cascading clear crystal droplets on a chrome canopy. G9 bulb. 20 cm dia x 45 cm drop. A little jhumar sparkle for powder rooms and vanity areas.",
  },
];

export const PROMISES = [
  {
    title: "All-inclusive pricing",
    body: "The price on the tag is the price you pay. GST is included and shown clearly at checkout.",
  },
  {
    title: "Secure checkout",
    body: "Pay by UPI, card or cash on delivery. We never store your card details.",
  },
  {
    title: "Delivered pan-India",
    body: "Dispatched within 48 hours with tracking, to addresses across the country.",
  },
  {
    title: "Easy 7-day returns",
    body: "Changed your mind? Start a return within 7 days and get refunded on a clear timeline.",
  },
];

export const TESTIMONIALS = [
  {
    initial: "R",
    name: "Rohit M.",
    city: "Bengaluru",
    body:
      "The chandelier arrived boxed like a jewel. Fitting was straightforward and the crystals catch light beautifully in the living room.",
  },
  {
    initial: "A",
    name: "Arjun S.",
    city: "Indore",
    body:
      "Bought pendants for our new kitchen. Solid brass finish, warm light, and the tag price was exactly what I paid \u2014 no surprises.",
  },
  {
    initial: "K",
    name: "Karan P.",
    city: "Pune",
    body:
      "Visited the Wanawadi store, then ordered online. Delivery was quick and the wall sconces look better in person than the photos.",
  },
];
